export const claimantRelationshipOptions = {
  SURVIVING_SPOUSE: 'I’m a Veteran’s surviving spouse',
  CUSTODIAN_FILING_FOR_CHILD_UNDER_18:
    'I’m a custodian filing for a Veteran’s child',
  SURVIVING_CHILD: 'I’m a Veteran’s adult child ',
  OTHER: 'None of these options apply to me',
};

export const childRelationshipToVeteranOptions = {
  BIOLOGICAL: 'I’m the Veteran’s biological child',
  ADOPTED: 'I’m the Veteran’s adopted child',
  STEPCHILD: 'I’m the Veteran’s stepchild',
};
